import { useState, useEffect } from "react"
import { Grid, Icon, IconButton } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import { Select } from "@gpstrackit/react-controls";
import { useIntl } from "react-intl";
//Components
import { SidePanel, Button } from "@gpstrackit/react-controls";

//Redux
import {
    searchEntityRequest,
    pmUsersGetUserRequest,
    clearRedux
} from "Redux/actions";


const AdvancedFilters = (props) => {
    const {
        openPanel,
        setOpenPanel,
        tableRef,
        platform,
        setPlatform,
        brand,
        setBrand,
    } = props;

    const { messages } = useIntl();

    const dispatch = useDispatch();

    //Redux States
    const loadingDevices = useSelector(state => state.commonRedux.loadingDataView);
    const user = useSelector(state => state.securityRedux.user);
    const userInfo = useSelector(state => state.usersCreateUserRedux.user)

    const { dealers } = useSelector(state => state.generalRedux);

    const [conditions, setConditions] = useState([]);
    const [dealersList, setDealersList] = useState([]);
    const [userInfoLocal, setUserInfoLocal] = useState(null)

    const handleApply = () => {
        tableRef?.current?.getData(null, null, null, conditions, null);
    }

    useEffect(() => {
        if (dealers && dealers.length > 0) {
            let list = JSON.parse(JSON.stringify(dealers))
            if (!list.find(x => x.id === 0) && userInfoLocal && userInfoLocal?.roles?.find(x => x.name === "Super Admin"))
                list.unshift({ id: 0, name: messages['packages_main_temaple'] });

            setDealersList(list)
        }
        if (userInfo) {
            dispatch(clearRedux("PM_USERS", { user: null }))
            setUserInfoLocal(userInfo)
            let list = JSON.parse(JSON.stringify(dealersList))
            if (!list.find(x => x.id === 0) && userInfo && userInfo?.roles?.find(x => x.name === "Super Admin"))
                list.unshift({ id: 0, name: messages['packages_main_temaple'] });

            setDealersList(list)

        }
    }, [dealers, userInfo]);

    useEffect(() => {
        openPanel && dealersList && dealersList.length === 0 && dispatch(searchEntityRequest({ key: "dealers" }));
        openPanel && user && dispatch(pmUsersGetUserRequest(user.userId));
        if (openPanel) setConditions(tableRef?.current?.conditions || [])
        else setConditions([])
    }, [openPanel]);

    let optionPlatform = [
        {
            id: "PM",
            name: "PM"
        },
        {
            id: "PX",
            name: "PX"
        }
    ]

    return (
        <SidePanel
            isOpen={openPanel}
            toggle={() => setOpenPanel(!openPanel)}
            sidePanelButtonStyle={(platform || brand) ? "side-panel-button" : "side-panel-button-white"}
        >
            <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='center'
            >
                <Grid item xs={8}>
                    <label style={{ fontSize: 'large', fontWeight: 500 }}>{messages['accounts_main_advanced_filters']}</label>
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', justifyContent: 'end' }}>
                    <IconButton
                        onClick={() => {
                            setBrand(null);
                            setPlatform(null);
                            let currentConditions = conditions

                            let deletePlatform = currentConditions.findIndex((item) => item.fields[0] === 'projectId');
                            deletePlatform >= 0 && currentConditions.splice(deletePlatform, 1);

                            let deleteBrand = currentConditions.findIndex((item) => item.fields[0] === 'dealerId');
                            deleteBrand >= 0 && currentConditions.splice(deleteBrand, 1);
                            setConditions(currentConditions);

                            tableRef?.current?.getData(null, null, null, currentConditions, null);

                        }}
                        size="large">
                        <Icon>delete</Icon>
                    </IconButton>
                </Grid>
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Button
                        className="btn btn-dark-blue btn-block"
                        onClick={(e) => {
                            e.preventDefault();
                            handleApply();
                        }}
                        disabled={loadingDevices}
                    >
                        {messages['devices_main_apply']}
                    </Button>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    <div>
                        <Select
                            id="platform"
                            label={messages['packages_main_project']}
                            placeholder={messages['select']}
                            value={optionPlatform.find(x => x.id === platform)}
                            onChange={(value) => {
                                setPlatform(value ? value.id : null);
                                let currentConditions = conditions;
                                let newConditions = currentConditions.filter((item) => item.fields[0] !== 'projectId');
                                if (value) newConditions.push({ fields: ["projectId"], terms: [`${value.id}`], exact: true, conditionOperator: "AND" })
                                setConditions(newConditions);
                            }}
                            options={optionPlatform}
                            textField="name"
                            valueField="id"
                            menuPlacement="auto"
                            isClearable={true}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    <div>
                        <Select
                            id="brand"
                            label={messages['packages_main_dealer']}
                            placeholder={messages['select']}
                            value={dealersList && dealersList.length > 0 && dealersList.find(x => x.id === (brand ? +brand : -1))}
                            onChange={(value) => {
                                setBrand(value ? value.id : null);
                                let currentConditions = conditions;
                                let newConditions = currentConditions.filter((item) => item.fields[0] !== 'dealerId');
                                if (value) newConditions.push({ fields: ["dealerId"], terms: [`${value.id}`], exact: true, conditionOperator: "AND" })
                                setConditions(newConditions);
                            }}
                            options={dealersList || []}
                            textField="name"
                            valueField="id"
                            menuPlacement="auto"
                            isClearable={true}
                        />
                    </div>
                </Grid>
            </Grid>
        </SidePanel>
    );
}
export default AdvancedFilters